export default __webpack_public_path__ + "static/media/warehouse-dark.2f597349.png";